import { element } from 'angular';
export var CopyLinkButtonDirective = [
    function () {
        var copyLink = function ($scope, $element) {
            element($scope.textareaSelector).select();
            document.execCommand('copy');
            element($element)
                .addClass('success')
                .html($scope.linkHtmlSuccess);
        };
        return {
            link: function ($scope, $element) {
                $element.on('click', function () {
                    copyLink($scope, $element);
                });
                $scope.$on('$destroy', function () {
                    $element.off('click');
                });
            },
            restrict: 'E',
            scope: {
                linkHtmlSuccess: '<',
                textareaSelector: '<',
            },
        };
    },
];
